/*
  Crochetree wishlist
  Saves wishlisted products in the visitor's browser (localStorage).
  No customer account, no third party app, no external requests.
*/
(function () {
  'use strict';

  var ctT = function (k, fb) { var d = window.CT_I18N || {}; return (d[k] !== undefined && d[k] !== null && d[k] !== '') ? d[k] : fb; };

  var KEY = 'crochetree:wishlist:v1';
  var EVENT = 'crochetree:wishlist:updated';

  /* ---------------------------------------------------------------- store */

  function read() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (item) {
        return item && typeof item.handle === 'string' && item.handle.length;
      });
    } catch (e) {
      return [];
    }
  }

  /*
    `source` is 'local' for a change the shopper just made here, or 'remote' for one
    handed to us by account sync. The sync script uses it to avoid echoing a write
    it just received straight back to the server.
  */
  function write(items, source) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      /* private browsing or storage full: the UI still updates for this page view */
    }
    document.dispatchEvent(
      new CustomEvent(EVENT, { detail: { items: items, source: source || 'local' } })
    );
  }

  function has(handle) {
    return read().some(function (item) {
      return item.handle === handle;
    });
  }

  function add(handle, id, title) {
    var items = read();
    if (items.some(function (item) { return item.handle === handle; })) return items;
    items.unshift({ handle: handle, id: id || null, title: title || '', addedAt: Date.now() });
    write(items);
    return items;
  }

  function remove(handle) {
    var items = read().filter(function (item) {
      return item.handle !== handle;
    });
    write(items);
    return items;
  }

  function toggle(handle, id, title) {
    return has(handle) ? (remove(handle), false) : (add(handle, id, title), true);
  }

  /* -------------------------------------------------------------- helpers */

  function rootUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function formatMoney(cents, format) {
    var formatString = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholder);
    if (!match) return formatString;

    function withDelimiters(number, precision, thousands, decimal) {
      if (isNaN(number) || number === null) return '0';
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }
    return formatString.replace(placeholder, value);
  }

  function escapeHtml(string) {
    return String(string == null ? '' : string).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
      }[character];
    });
  }

  /* ---------------------------------------------------------- button state */

  function syncButtons(scope) {
    var buttons = (scope || document).querySelectorAll('[data-wishlist-toggle]');
    var items = read();

    Array.prototype.forEach.call(buttons, function (button) {
      var saved = items.some(function (item) {
        return item.handle === button.getAttribute('data-wishlist-handle');
      });
      var title = button.getAttribute('data-wishlist-title') || ctT('ct.js.wishlist_this_product', 'this product');
      var label = saved
        ? ctT('ct.js.wishlist_saved', 'Saved to wishlist')
        : ctT('ct.js.wishlist_add', 'Add to wishlist');

      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('title', label);
      button.setAttribute(
        'aria-label',
        (saved
          ? ctT('ct.js.wishlist_remove_title_aria', 'Remove [title] from your wishlist')
          : ctT('ct.js.wishlist_add_title_aria', 'Add [title] to your wishlist')
        ).replace('[title]', function () { return title; })
      );

      var text = button.querySelector('[data-wishlist-label]');
      if (text) text.textContent = label;
    });
  }

  function syncCounts() {
    var total = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-count]'), function (node) {
      node.textContent = total;
      node.closest('[data-wishlist-count-wrapper]')?.classList.toggle('is-empty', total === 0);
    });
  }

  /* --------------------------------------------------------------- clicks */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var saved = toggle(
      button.getAttribute('data-wishlist-handle'),
      button.getAttribute('data-wishlist-id'),
      button.getAttribute('data-wishlist-title')
    );

    if (saved) {
      button.classList.remove('is-bumping');
      /* restart the animation even on a rapid re-click */
      void button.offsetWidth;
      button.classList.add('is-bumping');
    }
  });

  document.addEventListener(EVENT, function () {
    syncButtons();
    syncCounts();
  });

  /* keep tabs in the same browser in step */
  window.addEventListener('storage', function (event) {
    if (event.key !== KEY) return;
    syncButtons();
    syncCounts();
    if (window.CrochetreeWishlist.page) window.CrochetreeWishlist.page.render();
  });

  /* collection filters and quick add modals inject cards after load */
  function watchForNewButtons() {
    if (!window.MutationObserver) return;
    var pending = null;
    new MutationObserver(function () {
      window.clearTimeout(pending);
      pending = window.setTimeout(function () {
        syncButtons();
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    syncButtons();
    syncCounts();
    watchForNewButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    syncButtons();
    syncCounts();
  });

  /* ---------------------------------------------------------- wishlist page */

  function WishlistPage(container) {
    this.container = container;
    this.grid = container.querySelector('[data-wishlist-grid]');
    this.empty = container.querySelector('[data-wishlist-empty]');
    this.loading = container.querySelector('[data-wishlist-loading]');
    this.actions = container.querySelector('[data-wishlist-actions]');
    this.moneyFormat = container.getAttribute('data-money-format') || '${{amount}}';
    this.cache = {};

    var self = this;
    this.container.addEventListener('click', function (event) {
      var removeButton = event.target.closest('[data-wishlist-remove]');
      if (removeButton) {
        event.preventDefault();
        remove(removeButton.getAttribute('data-wishlist-remove'));
        return;
      }

      var addButton = event.target.closest('[data-wishlist-add-to-cart]');
      if (addButton) {
        event.preventDefault();
        self.addToCart(addButton);
        return;
      }

      var addAll = event.target.closest('[data-wishlist-add-all]');
      if (addAll) {
        event.preventDefault();
        self.addAllToCart(addAll);
      }
    });

    document.addEventListener(EVENT, function () {
      self.render();
    });

    this.render();
  }

  WishlistPage.prototype.fetchProduct = function (handle) {
    if (this.cache[handle]) return Promise.resolve(this.cache[handle]);

    var self = this;
    return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (product) {
        self.cache[handle] = product;
        return product;
      })
      .catch(function () {
        return null;
      });
  };

  WishlistPage.prototype.render = function () {
    var items = read();
    var self = this;

    if (!items.length) {
      this.grid.innerHTML = '';
      this.grid.hidden = true;
      this.loading.hidden = true;
      this.empty.hidden = false;
      if (this.actions) this.actions.hidden = true;
      return;
    }

    this.empty.hidden = true;
    if (this.grid.hidden) this.loading.hidden = false;

    Promise.all(
      items.map(function (item) {
        return self.fetchProduct(item.handle);
      })
    ).then(function (products) {
      var stale = [];
      var cards = [];

      products.forEach(function (product, index) {
        if (!product) {
          stale.push(items[index].handle);
          return;
        }
        cards.push(self.cardMarkup(product));
      });

      /* a product that no longer exists silently drops off the list */
      if (stale.length) {
        write(
          read().filter(function (item) {
            return stale.indexOf(item.handle) === -1;
          })
        );
        return;
      }

      self.loading.hidden = true;
      self.grid.hidden = false;
      self.grid.innerHTML = cards.join('');
      if (self.actions) self.actions.hidden = cards.length < 2;
    });
  };

  WishlistPage.prototype.cardMarkup = function (product) {
    var url = rootUrl() + 'products/' + product.handle;
    var image = product.featured_image
      ? '<img src="' + escapeHtml(sizedImage(product.featured_image, 500)) +
        '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="500" height="500">'
      : '<span class="wishlist-card__placeholder" aria-hidden="true"></span>';

    var price = '<span class="wishlist-card__price">' + formatMoney(product.price, this.moneyFormat) + '</span>';
    if (product.compare_at_price > product.price) {
      price +=
        '<s class="wishlist-card__compare">' +
        formatMoney(product.compare_at_price, this.moneyFormat) +
        '</s>';
    }

    var action;
    if (!product.available) {
      action = '<button type="button" class="wishlist-card__button" disabled>' + ctT('ct.js.wishlist_sold_out', 'Sold out') + '</button>';
    } else if (product.variants.length > 1) {
      action = '<a class="wishlist-card__button" href="' + escapeHtml(url) + '">' + ctT('ct.js.wishlist_choose_options', 'Choose options') + '</a>';
    } else {
      action =
        '<button type="button" class="wishlist-card__button" data-wishlist-add-to-cart="' +
        product.variants[0].id +
        '">' + ctT('ct.js.wishlist_add_to_cart', 'Add to cart') + '</button>';
    }

    return (
      '<li class="wishlist-card">' +
      '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' +
      escapeHtml(product.handle) +
      '" aria-label="' +
      ctT('ct.js.wishlist_remove_title_aria', 'Remove [title] from your wishlist').replace('[title]', function () {
        return escapeHtml(product.title);
      }) +
      '" title="' + ctT('ct.js.wishlist_remove', 'Remove from wishlist') + '">' +
      '<svg viewBox="0 0 14 14" width="13" height="13" aria-hidden="true" focusable="false">' +
      '<path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '</svg>' +
      '</button>' +
      '<a class="wishlist-card__media" href="' + escapeHtml(url) + '" tabindex="-1" aria-hidden="true">' +
      image +
      '</a>' +
      '<div class="wishlist-card__info">' +
      '<h3 class="wishlist-card__title"><a href="' + escapeHtml(url) + '">' + escapeHtml(product.title) + '</a></h3>' +
      '<div class="wishlist-card__prices">' + price + '</div>' +
      action +
      '</div>' +
      '</li>'
    );
  };

  WishlistPage.prototype.addToCart = function (button) {
    var variantId = button.getAttribute('data-wishlist-add-to-cart');
    var original = button.textContent;
    button.disabled = true;
    button.textContent = ctT('ct.js.wishlist_adding', 'Adding...');

    return this.postToCart([{ id: Number(variantId), quantity: 1 }])
      .then(function (ok) {
        button.textContent = ok
          ? ctT('ct.js.wishlist_added', 'Added')
          : ctT('ct.js.wishlist_try_again', 'Try again');
        window.setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1800);
      });
  };

  WishlistPage.prototype.addAllToCart = function (button) {
    var self = this;
    var items = read();
    var original = button.textContent;

    button.disabled = true;
    button.textContent = ctT('ct.js.wishlist_adding', 'Adding...');

    return Promise.all(
      items.map(function (item) {
        return self.fetchProduct(item.handle);
      })
    ).then(function (products) {
      var lines = products
        .filter(function (product) {
          return product && product.available && product.variants.length === 1;
        })
        .map(function (product) {
          return { id: product.variants[0].id, quantity: 1 };
        });

      if (!lines.length) {
        button.textContent = ctT('ct.js.wishlist_nothing_to_add', 'Nothing to add');
        window.setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1800);
        return;
      }

      return self.postToCart(lines).then(function (ok) {
        button.textContent = ok
          ? ctT('ct.js.wishlist_added_to_cart', 'Added to cart')
          : ctT('ct.js.wishlist_try_again', 'Try again');
        window.setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1800);
      });
    });
  };

  WishlistPage.prototype.postToCart = function (lines) {
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    var body = { items: lines };

    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    return fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status && response.status !== 200) return false;

        if (useDrawer) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(response);
        } else {
          updateCartBubble();
        }
        return true;
      })
      .catch(function () {
        return false;
      });
  };

  function updateCartBubble() {
    fetch(rootUrl() + 'cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
        if (bubble) bubble.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------ boot */

  window.CrochetreeWishlist = {
    read: read,
    add: add,
    remove: remove,
    has: has,
    toggle: toggle,
    replaceAll: function (items, source) {
      if (!Array.isArray(items)) return read();
      var clean = items
        .filter(function (item) {
          return item && typeof item.handle === 'string' && item.handle.length;
        })
        .map(function (item) {
          return {
            handle: item.handle,
            id: item.id || null,
            title: item.title || '',
            addedAt: item.addedAt || Date.now()
          };
        });
      write(clean, source);
      return clean;
    },
    count: function () { return read().length; },
    sync: function () { syncButtons(); syncCounts(); },
    page: null
  };

  function bootPage() {
    var container = document.querySelector('[data-wishlist-page]');
    if (container && !window.CrochetreeWishlist.page) {
      window.CrochetreeWishlist.page = new WishlistPage(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootPage);
  } else {
    bootPage();
  }

  document.addEventListener('shopify:section:load', bootPage);
})();
